import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "flex flex-col py-5 px-4 justify-center space-y-4" }
const _hoisted_2 = { class: "flex flex-col space-y-1" }
const _hoisted_3 = { class: "flex flex-col space-y-2" }
const _hoisted_4 = { class: "text-left text-sm" }
const _hoisted_5 = { class: "flex flex-col space-y-1" }
const _hoisted_6 = { class: "text-left text-sm line-clamp-3" }
const _hoisted_7 = {
  key: 0,
  class: "flex flex-col space-y-1"
}
const _hoisted_8 = { class: "space-y-2 flex flex-col" }
const _hoisted_9 = { class: "my-auto text-base font-medium" }
const _hoisted_10 = { class: "my-auto text-base font-medium" }

import {
  actionSheetController,
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonPage,
  IonTitle,
  IonToolbar, modalController,
  onIonViewWillEnter,
  useIonRouter,
} from '@ionic/vue';
import {computed, defineComponent, inject, Ref, ref} from 'vue';
import ApiService from "@/services/api/apiService";
import {DateTime} from "luxon";
import MenuButton from "@/components/MenuButton.vue";
import AuthService from "@/services/api/auth/authService";
import {Preferences} from "@capacitor/preferences";
import {PreferenceKey} from "@/definitions/PreferenceKey";
import JoinPremiumCard from "@/components/JoinPremiumCard.vue";
import useCamera from "@/composables/useCamera";
import {CameraResultType, CameraSource} from "@capacitor/camera";
import {Observable, ObservableEvent} from "@/services/observable/Observable";
import {UserInterface} from "@/interfaces/UserInterface";
import {useUser} from "@/composables/useUser";
import {AccountType} from "@/definitions/AccountType";
import pluralize from "pluralize";
import {UserProfileInterface} from "@/interfaces/UserProfileInterface";
import FeedNewPostPage from "@/views/feed/FeedNewPostPage.vue";
import ProfileSettingsProfile from "@/views/user/profile/ProfileSettingsProfile.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ProfileSettingsPersonal',
  setup(__props) {

const user: Ref<UserInterface | undefined> = inject('user') as Ref<UserInterface | undefined>
const loading = ref(true)
const ionRouter = useIonRouter()
const busy = ref(false)

onIonViewWillEnter(async () => {
  loading.value = false
})

const goBack = async () => {
  await ionRouter.back()
}

const edit = async (slug: string) => {
  await ionRouter.navigate({name: `ProfileSettings${slug}`}, 'forward', 'push')
}

const viewProfile = async (profile: UserProfileInterface) => {
  const modal = await modalController.create({
    component: ProfileSettingsProfile,
    mode: 'ios',
    componentProps: {
      profile
    },
    presentingElement: document.getElementById('tabs') as HTMLElement,
  })
  await modal.present()
}

const newProfile = async () => {

  if (busy.value) return
  busy.value = true

  const profile = await ApiService.User().createProfile()
  await viewProfile(profile)

}





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonHeader), null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonToolbar), null, {
            default: _withCtx(() => [
              _createVNode(_unref(IonButtons), {
                slot: "start",
                class: "mr-4"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonButton), {
                    onClick: goBack,
                    class: "bg-brand-dark-gray rounded-md"
                  }, {
                    default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                      _createElementVNode("svg", {
                        class: "",
                        width: "24",
                        height: "24",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg"
                      }, [
                        _createElementVNode("path", {
                          d: "M6 11.9961H18",
                          stroke: "white",
                          "stroke-width": "2",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round"
                        }),
                        _createElementVNode("path", {
                          d: "M12 18L6 12L12 6",
                          stroke: "white",
                          "stroke-width": "2",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round"
                        })
                      ], -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_unref(IonTitle), { class: "text-white font-medium text-2xl" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(user).account_type === _unref(AccountType).Club ? 'Business Details' : 'Profile'), 1)
                ]),
                _: 1
              }),
              (_unref(user).account_type === _unref(AccountType).Joint)
                ? (_openBlock(), _createBlock(_unref(IonButtons), {
                    key: 0,
                    slot: "end"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonButton), {
                        onClick: newProfile,
                        class: "bg-brand-dark-gray rounded-md"
                      }, {
                        default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                          _createElementVNode("div", { class: "rounded-md bg-white w-7 h-7 flex text-brand-black" }, [
                            _createElementVNode("svg", {
                              class: "w-4 h-4 m-auto fill-current",
                              xmlns: "http://www.w3.org/2000/svg",
                              viewBox: "0 0 448 512"
                            }, [
                              _createElementVNode("path", { d: "M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32V224H48c-17.7 0-32 14.3-32 32s14.3 32 32 32H192V432c0 17.7 14.3 32 32 32s32-14.3 32-32V288H400c17.7 0 32-14.3 32-32s-14.3-32-32-32H256V80z" })
                            ])
                          ], -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(IonContent), { class: "h-full" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(user).profiles, (profile) => {
                  return (_openBlock(), _createBlock(MenuButton, {
                    onClick: ($event: any) => (viewProfile(profile)),
                    key: profile.id,
                    name: "Name"
                  }, {
                    bottom: _withCtx(() => [
                      _createElementVNode("div", _hoisted_4, _toDisplayString(profile.name ?? '--'), 1)
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                }), 128))
              ])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(MenuButton, {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (edit('Bio'))),
                name: "Bio"
              }, {
                bottom: _withCtx(() => [
                  _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(user).bio.replace(/<[^>]*>/g, '')), 1)
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (edit('Location'))),
              class: "flex flex-col space-y-1"
            }, [
              (!_unref(user).location)
                ? (_openBlock(), _createBlock(MenuButton, {
                    key: 0,
                    name: "Set location..."
                  }))
                : _createCommentVNode("", true),
              (_unref(user).location)
                ? (_openBlock(), _createBlock(MenuButton, {
                    key: 1,
                    name: _unref(user).location.name
                  }, null, 8, ["name"]))
                : _createCommentVNode("", true)
            ]),
            (![_unref(AccountType).Club].includes(_unref(user).account_type))
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _cache[6] || (_cache[6] = _createElementVNode("div", { class: "text-white font-medium text-lg" }, "Preferences", -1)),
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(MenuButton, {
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (edit('LookingFor'))),
                      name: "Looking for"
                    }, {
                      bottom: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(user).sexual_interests, (interest) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: interest.id,
                            class: "flex bg-brand-lime text-brand-dark-gray justify-between p-4 py-2 rounded-full min-w-max mt-1.5 mr-1.5"
                          }, [
                            _createElementVNode("div", _hoisted_9, _toDisplayString(interest.name), 1)
                          ]))
                        }), 128))
                      ]),
                      _: 1
                    }),
                    _createVNode(MenuButton, {
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (edit('Kinks'))),
                      name: "Kinks"
                    }, {
                      bottom: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(user).desires, (kink) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: kink.id,
                            class: "flex bg-brand-lime text-brand-dark-gray justify-between p-4 py-2 rounded-full min-w-max mt-1.5 mr-1.5"
                          }, [
                            _createElementVNode("div", _hoisted_10, _toDisplayString(kink.name), 1)
                          ]))
                        }), 128))
                      ]),
                      _: 1
                    })
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})